import React, { useContext, useEffect, useState } from 'react';
import styles from './AssignPartnerForm.module.scss';
import { Input, Select } from 'esa-ui-library';
import { Form } from '../../../components';
import { useStore } from '../../../../common';
import { PropertyType } from 'esa-ui-library/lib/types';
import { AuthContext } from '../../../../logic';
import { validateProvidersForm } from '../GameProviders.helper';

interface AssignPartnerFormProps {
	onValidityChange?: (isValid: boolean) => void;
}

const AssignPartnerForm = ({ onValidityChange }: AssignPartnerFormProps): JSX.Element => {
	const [state, dispatch] = useStore();
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [isLoading, setIsLoading] = useState(true);
	const { token } = useContext(AuthContext);
	const { success, formErrors, gameProviderPartnerForm, selectedGame, activePartners, allSkins } = state;
	const [form, setForm] = useState(gameProviderPartnerForm);

	useEffect(() => {
		setForm(gameProviderPartnerForm);
	}, [gameProviderPartnerForm]);

	const options = (allSkins.gamePartners || []).map((skin: { name: any; skinid: any }) => ({
		label: skin.name,
		value: String(skin.skinid),
	}));

	const getGame = async () => {
		setIsLoading(true);
		await dispatch('GAME_INIT', { token, id: selectedGame.internal_game_id });
		setIsLoading(false);
	};

	const onPartnersChange = (val: PropertyType[]) => {
		dispatch('PARTNERS_UPDATE', val);
		dispatch('FORM_GAME_PARTNERS', { activePartners: val });
	};

	useEffect(() => {
		if (selectedGame) {
			getGame();
		}
	}, [selectedGame?.internal_game_id]);

	useEffect(() => {
		if (!selectedGame) {
			dispatch('PARTNERS_UPDATE', []);
			dispatch('FORM_GAME_PARTNERS', { activePartners: [] });
			onValidityChange?.(false);
		}
	}, [selectedGame]);

	const onChange = (field: string, val: string) => {
		setForm((prev: any) => ({ ...prev, [field]: val }));
		dispatch('PARTNERS_FORM', { field, value: val });
	};

	useEffect(() => {
		const combinedForm = {
			...gameProviderPartnerForm,
			activePartners,
		};

		if (typeof activePartners === 'undefined') {
			onValidityChange?.(false);
			return;
		}

		const errors = validateProvidersForm(combinedForm);
		onValidityChange?.(!errors);
	}, [gameProviderPartnerForm, activePartners]);

	return (
		// <section className={isLoading ? styles.DisableForm : ''}>
		<section>
			<Form success={success}>
				<div>
					<Select
						label='Partner'
						options={options}
						placeholder={'Select partner'}
						selected={activePartners}
						required
						dataId='partner-field'
						onChange={onPartnersChange}
						error={!!formErrors?.activePartners}
						errorMessage={formErrors?.activePartners}
						search={true}
					/>
					<Input
						className={styles.Input}
						type='text'
						label='Short name test'
						value={form.short_name_test}
						placeholder='Enter short name test'
						dataId='game-provider-short-name-test-field'
						required
						onChange={(val) => onChange('short_name_test', val)}
						error={!!formErrors?.short_name_test}
						errorMessage={formErrors?.short_name_test}
					/>
					<Input
						className={styles.Input}
						type='text'
						label='Short name live'
						value={form.short_name_live}
						placeholder='Enter short name live'
						dataId='game-provider-short-name-live-field'
						required
						onChange={(val) => onChange('short_name_live', val)}
						error={!!formErrors?.game_provider_name}
						errorMessage={formErrors?.game_provider_name}
					/>
				</div>
			</Form>
		</section>
	);
};

export { AssignPartnerForm };
